import { wrapper, createApiClient } from "../base";
import { AxiosProgressEvent } from "axios";
import UserUploadedFileDTO = App.Data.Explorer.Filter.UserUploadedFileDTO;

const basePath = `/files`;
const baseClient = createApiClient();

export default class {
	store(
		fileUuid: string,
		file: File,
		progressTracker?: (progressEvent: AxiosProgressEvent) => void
	) {
		const formData = new FormData();
		formData.append("uuid", fileUuid);
		formData.append("file", file);

		return wrapper<UserUploadedFileDTO>(
			baseClient.post(basePath, formData, {
				onUploadProgress: progressTracker,
			})
		);
	}

	getDownloadUrl(fileUuid: string) {
		return wrapper<{ url: string }>(
			baseClient.get(`${basePath}/${fileUuid}/download-url`)
		);
	}
}
